import helper from '../../../helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('portaliSchedeHotel');
export const actions = helper.createActions('portaliSchedeHotel', actionTypes);
